import React from 'react';
import { useTranslation } from 'react-i18next';
import { FaChevronDown, FaChevronUp } from 'react-icons/fa';
import { NS } from '../../U3130';

export type U3130ApproveDialogPanelProps = {
  panelId: string;
  title: string;
  titleClassName: string;
  panelClassName: string;
  helpExpanded: boolean;
  onToggleHelp: () => void;
  helpContent: React.ReactNode;
  children: React.ReactNode;
};

/** BL-0637 — panneau dialogue Approuver avec aide repliée (pattern U3129). */
const U3130ApproveDialogPanel: React.FC<U3130ApproveDialogPanelProps> = ({
  panelId,
  title,
  titleClassName,
  panelClassName,
  helpExpanded,
  onToggleHelp,
  helpContent,
  children,
}) => {
  const { t } = useTranslation();
  const helpToggleId = `${panelId}-help-toggle`;
  const helpRegionId = `${panelId}-help-region`;

  return (
    <div className={`space-y-3 rounded-lg border p-3 ${panelClassName}`}>
      <div className="flex flex-wrap items-center justify-between gap-2">
        <p className={`text-xs font-medium ${titleClassName}`}>{title}</p>
        <button
          type="button"
          id={helpToggleId}
          aria-expanded={helpExpanded}
          aria-controls={helpRegionId}
          onClick={onToggleHelp}
          className="inline-flex shrink-0 items-center gap-1.5 rounded-sm py-0.5 px-1 text-xs font-medium text-gray-600 select-none hover:bg-white/60 hover:text-gray-900 focus:outline-hidden focus:ring-2 focus:ring-blue-500/20"
        >
          {t('dlgApprovePanelHelpToggle', { ns: NS, defaultValue: 'Aide' })}
          {helpExpanded ? (
            <FaChevronUp className="h-3 w-3" aria-hidden />
          ) : (
            <FaChevronDown className="h-3 w-3" aria-hidden />
          )}
        </button>
      </div>
      {helpExpanded && (
        <div id={helpRegionId} role="region" aria-labelledby={helpToggleId} className="space-y-2 text-xs">
          {helpContent}
        </div>
      )}
      {children}
    </div>
  );
};

export default U3130ApproveDialogPanel;
